import { titlePageInitialLabel } from '@/constants'
import { useEffect } from 'react'
import { useLocation } from 'react-router'
import './../RouterErrorHandler.scss'

const AccessDeniedHandler = () => {
  const location = useLocation()

  useEffect(() => {
    document.title = `${titlePageInitialLabel} - Error`
  }, [])

  return (
    <>
      <div className="error-container">
        <div className="error-content">
          <h1>Accesso Negato :(</h1>
          <h2>Consultare un amministratore per ricevere informazioni</h2>
          {location.key !== 'default' && (
            <p>
              Clicca{' '}
              <a href={'/'} className="reload-link">
                qui
              </a>{' '}
              per tornare a dashboard
            </p>
          )}
        </div>
      </div>
    </>
  )
}

export default AccessDeniedHandler
